module.exports = __webpack_public_path__ + "img/img41.bcc055b5.svg";